module.exports = __webpack_public_path__ + "static/media/bazterrica-login.9e79c7b6.svg";